module.exports = __FOREMAN_VENDOR__REDUX__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REDUX__"
// module id = redux
// module chunks = 0